import { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Select, Space } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

const { Option } = Select;

interface VendorEvaluationCreateComponentProps {
  expenseCommon: any;
  onCreate: (data: any) => void;
  onCancel: () => void;
}

function VendorEvaluationCreateComponent({
  expenseCommon,
  onCreate,
  onCancel,
}: VendorEvaluationCreateComponentProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [projectList, setProjectList] = useState<any[]>();

  useEffect(() => {
    if (!mount) return;
    let children: any = [];
    for (const project of expenseCommon.projectList.sort((a: any, b: any) =>
      b.startDate.localeCompare(a.startDate),
    )) {
      children.push(
        <Option key={project.id} value={project.id}>
          {project.name} ({project.startDate} ~ {project.endDate})
        </Option>,
      );
    }
    setProjectList(children);

    return () => setMount(false);
  }, [expenseCommon, mount]);

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={onCreate}
        initialValues={{
          score: '100',
        }}
      >
        <Row>
          <Col span={24}>
            <Form.Item name="projectId" label="프로젝트">
              <Select style={{ width: '100%' }}>{projectList}</Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              name="comment"
              label="평가자 의견"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              name="score"
              label="점수"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select allowClear style={{ width: '100%' }}>
                <Option value="0">0</Option>
                <Option value="20">20</Option>
                <Option value="40">40</Option>
                <Option value="60">60</Option>
                <Option value="80">80</Option>
                <Option value="100">100</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Form.Item>
            <Space size="middle">
              <Button htmlType="button" onClick={onCancel}>
                취소
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100px' }}
              >
                확인
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
}

export default VendorEvaluationCreateComponent;
